module.exports = __webpack_public_path__ + "static/glancebg.8382b297.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/glancebg.jpg
// module id = 1357
// module chunks = 94883237073720 175223062182307